/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */
:host {
  --background: var(--nve-sys-layer-container-background);
  --color: var(--nve-sys-text-muted-color);
  --indicator-color: var(--nve-sys-support-accent-color);
  --border-radius: var(--nve-ref-border-radius-md);

  position: absolute;
  inset-block-end: var(--nve-ref-space-xs);
  inset-inline-end: var(--nve-ref-space-xs);
  display: block;
  box-sizing: border-box;
  inline-size: clamp(8rem, 32%, 10rem);
  max-inline-size: calc(100% - 1rem);
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: var(--border-radius);
  contain: content;
  cursor: default;
  user-select: none;
}

.surface {
  position: relative;
  inline-size: 100%;
  block-size: 100%;
}

svg {
  position: absolute;
  inset: 0;
  display: block;
  inline-size: 100%;
  block-size: 100%;
  overflow: hidden;
  border-radius: inherit;
}

.preview {
  position: absolute;
  inset: 0;
  transform-origin: 0 0;
  pointer-events: none;
}

.foreground-layer {
  pointer-events: none;
}

.background {
  fill: var(--background);
}

.item {
  fill: var(--color);
  pointer-events: none;
}

.visible-region {
  fill: var(--indicator-color);
  fill-opacity: 0.15;
  stroke: var(--indicator-color);
  stroke-width: 1.5;
  vector-effect: non-scaling-stroke;
  pointer-events: all;
}

:host(:state(pan-eligible)) .background {
  cursor: var(--recenter-cursor, pointer);
}

:host(:state(pan-eligible)) .visible-region {
  cursor: var(--pan-cursor, grab);
}

:host(:state(panning)),
:host(:state(panning)) .background,
:host(:state(panning)) .visible-region {
  cursor: var(--panning-cursor, grabbing);
}
